module.exports = __webpack_public_path__ + "media/images/share/background-c06307a01a01c56f745e652930081f91.jpg";